import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {Popover} from "@mui/material";
import TextField from "@mui/material/TextField";
import {InputMain, TextToolTip} from "components";
import {EscortAppPatientEnum} from "fragments";
import {legsActions} from 'store'
import {Svg} from 'assets'
import {Notify} from "utils";

export const AssignVehicle = ({item, requestParams}) => {
    const legsList = useSelector((state) => state.legs?.legsList);
    const vehiclesList = useSelector((state) => state.vehicles?.vehiclesList);
    const [showInput, setShowInput] = useState(false);
    const [inputValue, setInputValue] = useState(item?.vehicle?.unitNumber || '');
    const [selectedVehicle, setSelectedVehicle] = useState(normalizeVehicle(item?.vehicle) || null);
    const [anchorEl, setAnchorEl] = useState(null);
    const {control, setValue, watch} = useForm();
    const dispatch = useDispatch();
    const inputWrapperRef = useRef(null);
    const inputRef = useRef(null);
    const timeOutRef = useRef(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const searchVehicle = watch('vehicle');

    function normalizeVehicle  (vehicle)  {
        if (!vehicle) return null;
        return {
            ...vehicle,
            id: vehicle.id ?? vehicle._id ?? null,
        };
    }

    useEffect(() => {
        if (showInput && inputWrapperRef.current) {
            inputWrapperRef.current.focus();
            inputRef.current.focus();
        }
    }, [showInput]);

    useEffect(() => {
        if (!open) {
            if (timeOutRef.current) clearTimeout(timeOutRef.current);

            timeOutRef.current = setTimeout(() => {
                setValue('vehicle', '');
            }, 800);

            return () => clearTimeout(timeOutRef.current);
        }
    }, [open]);

    // useEffect(() => {
    //     if (!showInput) {
    //         const normalized = normalizeVehicle(item?.vehicle);
    //         setInputValue(normalized?.unitNumber || '');
    //         setSelectedVehicle(normalized);
    //     }
    // }, [showInput, item?.vehicle]);


    const handleChange = (value) => {
        const trimValue = value?.trim();

        if (trimValue) {
            const foundVehicle = vehiclesList?.vehicles?.find(
                v => v?.unitNumber?.toLowerCase?.() === trimValue?.toLowerCase()
            );
            setSelectedVehicle(foundVehicle || null);
        } else {
            setSelectedVehicle(null);
        }

        setInputValue(trimValue);
    }

    const handleSelectVehicle = (item) => {
        setAnchorEl(null);
        setSelectedVehicle(item);
        setInputValue(item.unitNumber);
    }

    const toggleMenu = (event) => {
        event ? setAnchorEl(event?.currentTarget) : setAnchorEl(null);
    };


    const handleAssignVehicle = () => {
        setAnchorEl(null);

        if (inputValue && !selectedVehicle?.id) {
            setInputValue(item?.vehicle?.unitNumber || '');
            setSelectedVehicle(item?.vehicle || null);
            Notify('Vehicle not found', 'error');
            return;
        }

        const updatedList = legsList?.legs?.map((leg) => {
            if (leg?.id !== item?.id) return leg;
            const params = {...leg};
            const isAssignedOrOpen = leg?.status === EscortAppPatientEnum.ASSIGNED
                || leg?.status === EscortAppPatientEnum.OPEN;

            if (!isAssignedOrOpen) {
                params.vehicle = selectedVehicle || leg?.vehicle;
            } else {
                // for sorting //
                // params.status = selectedVehicle ? EscortAppPatientEnum.ASSIGNED : EscortAppPatientEnum.OPEN;

                params.vehicle = selectedVehicle;
            }

            return params;
        });

        dispatch(legsActions.editLegList({legs: updatedList, count: legsList?.count}));

        const vehicleId = selectedVehicle?.id || null;
        const shouldAssign = item?.status !== EscortAppPatientEnum.ASSIGNED
        && item?.status !== EscortAppPatientEnum.OPEN
            ? !!selectedVehicle?.id
            : true;

        if (shouldAssign) {
            dispatch(legsActions.legAssignOrChangeData(item?.id, {vehicle: vehicleId}, true));

            // requestParams - for request all
            // dispatch(legsActions.legAssignOrChangeData(item?.id, {vehicle: vehicleId}, true, requestParams));
        }
    };


    return (
        <div className={`assign-vehicle-wrapper`}>
            {!showInput ?
                <TextToolTip
                    classNameText={`assign-vehicle-text ${item?.status === EscortAppPatientEnum.CANCELLED ? 'dont-assign-vehicle-text' : ''}`}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (item?.status !== EscortAppPatientEnum.CANCELLED) {
                            setShowInput(true)
                        }
                    }}
                    content={selectedVehicle?.unitNumber ? `${selectedVehicle?.unitNumber}` : 'Assign'}
                    text={selectedVehicle?.unitNumber ? `${selectedVehicle?.unitNumber}` : 'Assign'}
                    textStyles={{
                        color: selectedVehicle?.unitNumber ? '#51566d' : ''
                    }}
                />
                :
                <div
                    className='assign-vehicle-input-wrapper'
                    ref={inputWrapperRef}
                    tabIndex={-1}
                    onBlur={(e) => {
                        const nextFocusTarget = e.relatedTarget;
                        if (!inputWrapperRef.current.contains(nextFocusTarget)) {
                            const popover = document.querySelector('.assign-vehicle-popper');
                            if (!popover?.contains(nextFocusTarget)) {
                                setShowInput(false);
                                handleAssignVehicle();
                            }
                        }
                    }
                    }
                    onClick={(e) => e.stopPropagation()}
                >
                    <TextField
                        inputRef={inputRef}
                        className='assign-vehicle-input-block'
                        value={inputValue}
                        onChange={(e) => handleChange(e?.target?.value)}
                        InputProps={
                            {
                                endAdornment:
                                    <div
                                        className='assign-vehicle-input-arrow'
                                        style={{transform: open ? 'rotate(180deg)' : ''}}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleMenu({currentTarget: inputWrapperRef?.current});
                                        }}
                                    >
                                        <Svg.ArrowDownSvg/>
                                    </div>
                            }
                        }
                    />
                </div>
            }

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={(e) => {
                    e.stopPropagation();
                    toggleMenu()
                }}
                className={"assign-vehicle-popper"}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <h1 className='assign-vehicle-title'>
                    Assign Vehicle
                </h1>

                <InputMain
                    name={`vehicle`}
                    control={control}
                    rules={{
                        required: true
                    }}
                    allowErrorMessage={false}
                />
                {!!vehiclesList?.vehicles?.length &&
                    <ul className='assign-vehicle-list-wrapper'>
                        {vehiclesList?.vehicles?.sort((a, b) => a.unitNumber.localeCompare(b.unitNumber, undefined, {numeric: true}))?.filter((vehicle) => vehicle?.unitNumber?.toString()?.includes(searchVehicle || ''))?.map((vehicle) => (
                            <li
                                key={vehicle?.id}
                                className={`assign-vehicle-list-item ${vehicle?.id === selectedVehicle?.id ? 'assign-vehicle-list-item-selected' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleSelectVehicle(vehicle)
                                }}
                            >
                                <TextToolTip
                                    classNameText='assign-vehicle-list-item_text'
                                    content={vehicle?.unitNumber}
                                    text={vehicle?.unitNumber}
                                />
                            </li>
                        ))}
                    </ul>
                }
            </Popover>
        </div>
    );
};

